export default "__VITE_ASSET__Dvvlo4$e__"